<div class="relative flex flex-col bg-white rounded-xl overflow-hidden w-[90vw] max-w-3xl h-[85vh]">
  <div class="flex items-center justify-between px-4 py-3 border-b">
    <h2 class="font-semibold text-base">Manual de Empresarios</h2>
    <button
      (click)="dialogRef.close()"
      class="text-gray-500 hover:text-gray-800 transition-colors">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="w-5 h-5"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2">
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M6 18L18 6M6 6l12 12" />
      </svg>
    </button>
  </div>
  <iframe
    class="flex-1 w-full"
    [src]="pdfUrl"
    title="Manual de empresarios">
  </iframe>
</div>
